import {
  Body,
  Box,
  LocalizedString,
  Space,
  UniCreditIconProps,
} from "@dbn/omnichannel-design-system-g4p";

import {
  palette,
  spaceUnit,
} from "@dbn/omnichannel-design-system-g4p/lib/styleConstants";

type Props = {
  Icon: (props: UniCreditIconProps) => JSX.Element;
  heading: LocalizedString;
  subHeading?: LocalizedString;
  backgroundColor: string;
};

export function FeedbackMessage({
  heading,
  subHeading,
  Icon,
  backgroundColor,
}: Props) {
  return (
    <Box column hAlignContent="center">
      <div
        style={{
          height: "72px",
          width: "72px",
          padding: spaceUnit * 2,
          display: "inline-block",
          borderRadius: "50%",
          border: palette.blue800,
          backgroundColor: backgroundColor,
        }}
      >
        <Icon size={"x-large"} monochromatic color={palette.white} />
      </div>
      <Space units={6} />
      <Body size={"big"} weight={"medium"} align={"center"}>
        {heading}
      </Body>
      {subHeading && (
        <>
          <Space units={6} />
          <Body size={"small"} weight={"regular"} align={"center"}>
            {subHeading}
          </Body>
        </>
      )}
    </Box>
  );
}
